import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IBackdropComponentProps {
    title?: string;
    children: any;
    customExpandIcon?: JSX.Element;
    titleSx?: any;
    wrapperSx?: any;
    defaultExpanded?: boolean;
    leftElement?: JSX.Element;
    summarySx?: any;
}

export const AccordionComponent = (props: IBackdropComponentProps) => {
    const { title, children, customExpandIcon = <ExpandMoreIcon />, titleSx, wrapperSx, summarySx, defaultExpanded = false, leftElement = null } = props;

    return (
        <Accordion sx={{
            ...wrapperSx,
            '&:before': {
                display: 'none',
            }
        }} defaultExpanded={defaultExpanded}>
            <AccordionSummary
                expandIcon={customExpandIcon}
                sx={{ border: "none", ...summarySx }}
                aria-controls="panel1-content"
                id="panel1-header">
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {leftElement}
                    <Typography component="span" sx={{ ...titleSx }}>{title}</Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                {children}
            </AccordionDetails>
        </Accordion>
    );
}